﻿
import {
    trigger,
    style,
    animate,
    transition,
    state
} from '@angular/animations';

// nav menu
// breakage point
// user actually has to reload to reset this width
// if rotating a tablet crosses this boundary (1200)
export const sideWidth = window.screen.width > 1200 ?  (window.screen.width - 275).toString() +  'px' :
  (window.screen.width - 200).toString() + 'px';
export const filterAnimationDuration = 250;

export const filterAnimatedContent = trigger('filterAnimatedContent', [
    state('out, void', style({
        right: 0,
    })),
    state('in', style({
      // right: sideWidth,
    })),
    transition('out => in', [
        animate(filterAnimationDuration)
    ])
]);

export const filterAnimatedPanel = trigger('filterAnimatedPanel', [
    state('out, void', style({
        transform: 'translateX(100%)',
        // width: sideWidth,
        opacity: 0,
    })),
    state('in', style({
        transform: 'translateX(0)',
        // width: sideWidth,
        opacity: 1,
    })),
    transition('out => in', [
        animate(filterAnimationDuration)
    ])
]);
